import { useState, useEffect } from 'react'
import emailjs from '@emailjs/browser'
import { EJS_PUBLIC_KEY, EJS_SERVICE_ID, EJS_TEMPLATE } from '../../constants/emailjs'
import MFEBus from '../../mfe/MFEBus'
/**
 * ContactForm — controlled form wired to EmailJS.
 * Includes honeypot spam guard (hidden company field).
 * Emits contact:sent on the MFEBus on success.
 */
export function ContactForm() {
  const [f,    setF]    = useState({ name: '', email: '', phone: '', subject: '', message: '', company: '' })
  const [ok,   setOk]   = useState(false)
  const [err,  setErr]  = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => { emailjs.init(EJS_PUBLIC_KEY) }, [])

  const set = k => e => setF(p => ({ ...p, [k]: e.target.value }))

  const send = async () => {
    if (f.company) return                                       // honeypot triggered — silent exit
    if (!f.name.trim() || !f.email.trim() || !f.message.trim()) { alert('Please fill in your name, email and message.'); return }
    setBusy(true); setErr('')
    try {
      await emailjs.send(EJS_SERVICE_ID, EJS_TEMPLATE, {
        from_name: f.name.trim(),
        reply_to:  f.email.trim(),
        phone:     f.phone.trim() || '—',
        subject:   f.subject.trim() || 'Portfolio contact',
        message:   f.message.trim(),
      })
      setOk(true); MFEBus.emit('contact:sent', { from: f.name.trim() })
      setF({ name: '', email: '', phone: '', subject: '', message: '', company: '' })
      setTimeout(() => setOk(false), 5000)
    } catch (e) {
      console.error('EmailJS error:', e)
      setErr('Failed to send 😬  Please email devampatel1101@gmail.com directly.')
    }
    setBusy(false)
  }

  return (
    <div className="gls" style={{ padding: '1.75rem', marginTop: '2rem', textAlign: 'left' }}>
      {/* honeypot — invisible to humans, traps bots */}
      <input type="text" tabIndex={-1} aria-hidden="true" autoComplete="off" value={f.company} onChange={set('company')} style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}/>
      <div className="frow">
        <label className="flabel">Full name *<input className="finp" type="text"  placeholder="Your name"          value={f.name}    onChange={set('name')}    required/></label>
        <label className="flabel">Email *    <input className="finp" type="email" placeholder="you@example.com"    value={f.email}   onChange={set('email')}   required/></label>
      </div>
      <label className="flabel" style={{ display: 'block', marginBottom: '.85rem' }}>Phone<input className="finp" type="tel" placeholder="+61 4xx xxx xxx" value={f.phone}   onChange={set('phone')}/></label>
      <label className="flabel" style={{ display: 'block', marginBottom: '.85rem' }}>Subject<input className="finp" type="text" placeholder="Project, role, or question" value={f.subject} onChange={set('subject')}/></label>
      <label className="flabel" style={{ display: 'block', marginBottom: '.85rem' }}>Message *<textarea className="finp" placeholder="Tell me about your project or role…" value={f.message} onChange={set('message')} style={{ resize: 'vertical', minHeight: '110px' }}/></label>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
        <button className="btn bp" onClick={send} disabled={busy} style={{ opacity: busy ? .6 : 1, cursor: busy ? 'not-allowed' : 'pointer' }}>
          {busy ? 'Sending…' : 'Send Message →'}
        </button>
      </div>
      {ok  && <div className="fsuccess">✓ Message sent! Devam will get back to you soon.</div>}
      {err && <div className="fsuccess" style={{ background: 'rgba(239,68,68,.08)', borderColor: 'rgba(239,68,68,.28)', color: '#fca5a5' }}>{err}</div>}
    </div>
  )
}
